/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-08-19
 * Copyright All Rights Reserved
 */
// @flow
import * as React from 'react';
import { Button, Spinner } from 'reactstrap';
import { spinner } from './index.module.scss';

type Props = {
  children?: React.Node,
  className?: string,
  disabled?: boolean,
  onClick?: Function,
  submitting?: boolean,
  submittingText?: string,
  isSubmitType?: boolean,
}


const SubmitButton = ({
  children, className, disabled, onClick, submitting, submittingText, isSubmitType,
}: Props) => {
  const type = (isSubmitType ? { type: 'Submit' } : {});
  return (
    submitting ?
      <Button className={className} color="primary" {...type} disabled>
        <Spinner size="sm" className={spinner} /> {submittingText}
      </Button>
      :
      <Button
        disabled={disabled}
        className={className}
        color="primary"
        onClick={onClick}
        {...type}
      >
        {children}
      </Button>
  );
};

SubmitButton.defaultProps = {
  children: 'Submit',
  className: '',
  disabled: false,
  onClick: () => {},
  submitting: false,
  submittingText: 'Submitting...',
  isSubmitType: true,
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./js/components/support/buttons/SubmitButton/index.jsx